import { CommentAlertOutlineIcon } from './CommentAlertOutlineIcon';

/**
 * author: Austin Andrews
 * id CBAD69A4-A6FF-4A8A-AA85-B5962910106E
 * name comment-alert-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const CommentWarningOutlineIcon = CommentAlertOutlineIcon;
export default CommentWarningOutlineIcon